import Vue from 'vue'
import App from './App.vue'

// 引入element UI
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
Vue.use(ElementUI);

// 引入路由
import router from './router';

// 引入状态管理
import store from './vuex/store';

Vue.config.productionTip = false

import util from '@/utils/util.js'
Vue.prototype.$util = util;

new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>',
	data: {
		Bus: new Vue()
	}

})
